// ONLY ADD SOURCES TO THE BOTTOM AS WE ARE USING THIS FOR LOGGING!
var FolderPaneExpansionSource;
(function (FolderPaneExpansionSource) {
    FolderPaneExpansionSource[FolderPaneExpansionSource["Auto"] = 0] = "Auto";
    FolderPaneExpansionSource[FolderPaneExpansionSource["Init"] = 1] = "Init";
    FolderPaneExpansionSource[FolderPaneExpansionSource["LeftNavResizeExpand"] = 2] = "LeftNavResizeExpand";
    FolderPaneExpansionSource[FolderPaneExpansionSource["ToggleExpand"] = 3] = "ToggleExpand";
    FolderPaneExpansionSource[FolderPaneExpansionSource["ToggleCollapse"] = 4] = "ToggleCollapse";
    FolderPaneExpansionSource[FolderPaneExpansionSource["WindowResize"] = 5] = "WindowResize";
})(FolderPaneExpansionSource || (FolderPaneExpansionSource = {}));
export default FolderPaneExpansionSource;
//# sourceMappingURL=FolderPaneExpansionSource.js.map